import Utils from "../../../../../shared/utils"

export const IMAGE_URL = Utils.buildProductPageImageLink("mort/additional-mort/first-section-desk.png")

export const MAIN_TITLE_ICON = Utils.buildProductPageImageLink("icons/puzzle-house-icon.svg")